import styled from 'styled-components';

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  
  svg {
    width: 1em;
    height: 1em;
  }
`;
